/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import ReactGA from "react-ga4";
import "./public-path";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { StyledEngineProvider } from "@mui/material/styles";
import "react-phone-number-input/style.css";
// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { CategoryProvider } from "context/category-context";
import { AccountProvider } from "context/account";
import { StoreProvider } from "context/store";
import { CounterProvider } from "context/counter";
import { MyProjectsProvider } from "context/my-projects";
import { SharedContentProvider } from "context/shared-content";
import { UserSettingProvider } from "context/user-setting";

import { GoogleOAuthProvider } from "@react-oauth/google";

import "./index.css";
import "./index.less";

import toast, { Toaster } from "react-hot-toast";

const cache = createCache({
  key: "css",
  prepend: true,
});

function render(props) {
  const { container } = props;

  ReactGA.initialize("G-C7KXJG3DRD");

  const root = document.createElement("div");
  root.id = "root";
  container.appendChild(root);
  ReactDOM.createRoot(root).render(
    <GoogleOAuthProvider clientId="199434910923-5sauialim09fdeh1madfu8r7b6h8hse8.apps.googleusercontent.com">
      <AccountProvider>
        <StoreProvider>
          <UserSettingProvider>
            <CounterProvider>
              <SharedContentProvider>
                <MyProjectsProvider>
                  <CategoryProvider>
                    <StyledEngineProvider injectFirst>
                      <CacheProvider value={cache}>
                        <BrowserRouter>
                          <SoftUIControllerProvider>
                            <Toaster />
                            <App />
                          </SoftUIControllerProvider>
                        </BrowserRouter>
                      </CacheProvider>
                    </StyledEngineProvider>{" "}
                  </CategoryProvider>
                </MyProjectsProvider>
              </SharedContentProvider>
            </CounterProvider>
          </UserSettingProvider>
        </StoreProvider>
      </AccountProvider>
    </GoogleOAuthProvider>
  );
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({ container: document.body });
}

export async function bootstrap() {
  console.log("[react16] react app bootstraped");
}

export async function mount(props) {
  console.log("[react16] props from main framework", props);
  render(props);
}

export async function unmount(props) {
  const { container } = props;
  ReactDOM.unmountComponentAtNode(
    container ? container.querySelector("#root") : document.querySelector("#root")
  );
}
